import apiService from '@/services/apiService';

const actions = {
  getBenefitCategories({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/benefit-category/find-all', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  getBenefitCategoriesWithPaging({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/benefit-category/find-with-paging', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  postBenefitCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxelian-club/benefit-category', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  putBenefitCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelian-club/benefit-category/${payload.id}`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  orderCategory({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.put(`paxelian-club/benefit-category/${payload.id}/sequence`, payload.data)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
  deleteBenefitCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      apiService.delete(`paxelian-club/benefit-category/${id}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default actions;